import { useFetcher } from "@remix-run/react";
import { useContext, useEffect } from "react";
import { BookingFormContext } from "~/components/booking/ContextProvider";
import { type loader as barberSelectLoader } from "~/routes/resources+/book+/barber-select";
import { route } from "~/utils/route";
import * as RadioCard from "~/components/ui/radio-card";
import { Label } from "~/components/ui/label";

// @TODO - Render minimum height needed so no CLS
export function BarberSelect() {
  const context = useContext(BookingFormContext);
  if (!context) {
    throw new Error("BookingFormContext is not provided");
  }

  const {
    selectedBarberId,
    setSelectedBarberId,
    selectedLocationId,
    setSelectedDate,
    setSelectedServiceIds,
    setSelectedTime,
  } = context;

  const barberSelectFetcher = useFetcher<typeof barberSelectLoader>();

  useEffect(() => {
    barberSelectFetcher.load(
      route("/resources/book/barber-select", { locationId: selectedLocationId })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLocationId]);

  useEffect(() => {
    setSelectedBarberId("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLocationId]);

  return (
    <div>
      <Label className="px-6" htmlFor="barber-select">
        Barber
      </Label>
      <div className="mt-2" />
      <RadioCard.Root
        id="barber-select"
        className="px-6"
        onValueChange={(value) => {
          if (value === "any") {
            value = barberSelectFetcher.data!.barberWithLeastBookings!.id!;
          }

          setSelectedBarberId(value);
          setSelectedServiceIds([]);
          setSelectedDate("");
          setSelectedTime("");
        }}
        value={selectedBarberId}
      >
        {!selectedLocationId ? (
          <RadioCard.Item disabled value="" className="w-full">
            <RadioCard.Indicator />
            <span>Complete fields above</span>
          </RadioCard.Item>
        ) : (
          <>
            {barberSelectFetcher.data?.barbers.map((barber) => {
              if (!barber) {
                return null;
              }

              return (
                <RadioCard.Item
                  disabled={barberSelectFetcher.state !== "idle"}
                  image={barber.profilePictureSrc}
                  key={barber.id}
                  value={barber.id}
                >
                  <RadioCard.Indicator />
                  <span>{barber.name}</span>
                </RadioCard.Item>
              );
            })}
          </>
        )}
      </RadioCard.Root>
    </div>
  );
}
